import { HoverPointer } from "assets/GlobalStyled";
import styled from "styled-components/macro";

export const StyledReadMore = styled.div`
  float: right;
  margin-top: 10px;
  ${HoverPointer}
`;
